import './index.scss';
import { useMemo, useState } from 'react';
import ViewEventForm from './ViewEventForm';
import { Event } from '../../../store/events/eventTypes';
import BookEventInfo from '../../pages/book-events/BookEventInfo';
import {
  useCloseOldModal,
  useModalData,
} from '../../../store/modal/modalHooks';
import CancellationPolicy from '../../shared/cancellation-policy/CancellationPolicy';
import BookContainer from '../../shared/book-components/BookModalComponent/BookModalComponent';

const ViewBookEventModalContainer = () => {
  const closeModal = useCloseOldModal();
  const modalData = useModalData();
  const [showPolicy, setShowPolicy] = useState(false);

  const event: Event = modalData?.data.event;
  if (!event) {
    closeModal();
  }

  const InfoComponent = useMemo(() => {
    if (showPolicy) {
      return <CancellationPolicy policyId={event.policyId} />;
    }
    return <BookEventInfo event={event} />;
  }, [showPolicy]);

  return (
    <div className="book-event-modal">
      <BookContainer
        infoComponent={InfoComponent}
        formComponent={
          <ViewEventForm
            event={event}
            onSwitchShowPolicy={() => setShowPolicy(!showPolicy)}
            showPolicy={showPolicy}
          />
        }
      />
    </div>
  );
};

export default ViewBookEventModalContainer;
